import { ForwardedRef, RefCallback } from "react";

export default <T>(...refs: ForwardedRef<T>[]): RefCallback<T> =>
  (node: T) => {
    for (const ref of refs) {
      if (typeof ref === "function") ref(node);
      if (ref && "current" in ref) ref.current = node;
    }
  };
